import { store } from '../redux/store';
import { SHOW_SNACKBAR } from '../redux/Common/actionTypes';

export type SnackbarType = 'success' | 'error' | 'warning' | 'info';

/**
 * Dispatches the global CommonSnackbar with the given message + severity.
 * Use this instead of `alert(...)` in new code — non-blocking, matches
 * the rest of the app's toast UX.
 */
export function showSnackbar(
    message: string,
    type: SnackbarType = 'error',
    duration?: number
): void {
    store.dispatch({
        type: SHOW_SNACKBAR,
        payload: { isShowing: true, message, type, duration }
    } as any);
}
